module.exports = __webpack_public_path__ + "img/image-outline.png";